import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'classificationType',
})
export class ClassificationTypePipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const strValue = String(value).trim();

    switch (strValue.toLowerCase()) {
      case '0':
      case 'regular':
      case 'retail':
        return 'Retail';

      case '1':
      case 'professional':
      case 'profissional':
      case 'qualified':
      case 'sophisticated':
        return 'Qualified';

      case '2':
      case 'company':
      case 'institutional':
        return 'Institutional';

      default:
        return strValue;
    }
  }
}
